import React, { Component } from 'react';
import './KPI8.css';

import Select from '@acri-tools/react-tools/components/Select/Select';
import KPIs from '../KPIs';
import { date_timezone_compensated, get_graph_mode, get_kpi_product_type, get_month_dates, get_timeline_height, is_on_kpi_page, update_kpi_url } from '../../../_utils/kpi';
import FormFieldCheckbox from '@acri-tools/react-tools/components/FormFieldCheckbox/FormFieldCheckbox';
import Tabs from '@acri-tools/react-tools/components/Tabs/Tabs';
import Timeline from '../../../components/Timeline/Timeline';
import { getDateTimeString } from '@acri-tools/react-tools/utils/date';
import moment from 'moment';
import { drawPlugin } from '../../../_utils/graphs';
import { Scatter } from 'react-chartjs-2';
import { VerticalLinePlugin } from '../../../_utils/graphs';
import zoomPlugin from 'chartjs-plugin-zoom';
import * as Chart from 'chart.js';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';
import request from '@acri-tools/react-tools/utils/request';
import { API_URL } from '../../../_utils/config';
import { axiosErrorHandler, nullUndefined } from '@acri-tools/react-tools/utils/global';
import { connect } from 'react-redux';
import KPITable from '../../../components/KPITable/KPITable';
import classNames from 'classnames';
import { get_product_type_id, load_product_types } from '../../../_utils/product_types';
import { get_date_difference, to_local_iso_string } from '../../../_utils/date';
import KPIRefreshOverlay from '../../../components/KPIRefreshOverlay/KPIRefreshOverlay';
import * as chroma from 'chroma-js';
import TimelinessChart from '../../../components/TimelinessChart/TimelinessChart';
import Modal, { ModalClose } from '@acri-tools/react-tools/components/Modal/Modal';
Chart.plugins.register(zoomPlugin);

interface Props {

    // REDUX
    product_types?: any
    kpi?: any
}
interface State {
    loading: boolean
    refreshing: boolean

    productType: string
    base_productType: string

    startDate: string
    stopDate: string

    base_startDate?: string
    base_stopDate?: string

    updateStartDate: string
    updateStopDate: string

    log_file?: any

    // data
    orchestration_data?: any[]

    // export
    json_format: boolean
}
/**
 *  1. KPI SELECT
 *  2. 2 graphs, 1 per toggle seperated
 *      timeliness : scatter graph with duration / complete_date
 *      completeness start - stop - product-type
 *            (like kpi 2 - timeline): 
 *          - orbits start- stop
 *          - product 
 */
class KPI8 extends Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            refreshing: false,
            loading: false,

            ...this.default_values(true),

            json_format: false,
        }
    }
    async componentDidMount() {
        await load_product_types()

        await this.setState({
            ...this.default_values(true)
        })

        this.fetch_data(true)
    }
    async componentDidUpdate(prevProps: Props) {
        if (prevProps.kpi?.refresh !== this.props.kpi?.refresh) {
            await this.setState({
                ...this.default_values(true)
            })
            if (is_on_kpi_page(8)) {
                this.update_url()
            }
            this.fetch_data(true)
        }
    }


    default_values = (set_base?: boolean) => {
        return {
            ...get_kpi_product_type(this.state, set_base, true),
            ...get_month_dates(this.state, set_base)
        }
    }


    fetch_data = async (refresh?: boolean) => {
        if (refresh) this.setState({ refreshing: true, loading: true });
        else this.setState({ loading: true });
        

        try {
            let res = await request(`${API_URL}/api/v1/processing_orchestration`, {
                method: 'get',
                params: {
                    limit: 0,
                    expand: 'product, downlink_session',
                    // orderby:'start_date_time DESC',
                    filter: `product.product_type eq '${this.state.productType}'
                        and downlink_session.stop_date_time ge '${this.state.startDate}'
                        and downlink_session.stop_date_time le '${this.state.stopDate}'
                    `
                }
            })

            this.setState({
                orchestration_data: res.data.value
            });
        }
        catch (e) {
            console.error('fetch_data error', e);
        }
        finally {
            // this.setState({ loading: false })
            if (refresh) this.setState({ refreshing: false, loading: false });
            else this.setState({ loading: false });
        }
    }


    update_url = () => {
        update_kpi_url(8, {
            startDate: to_local_iso_string(this.state.startDate),
            stopDate: to_local_iso_string(this.state.stopDate),
            productType: this.state.productType
        })
    }

    update_filter = async (update: any) => {
        await this.setState(update);
        this.fetch_data();
    }

    applyChanges = async () => {
        await this.setState({
            startDate: this.state.updateStartDate,
            stopDate: this.state.updateStopDate
        })
        this.update_url()
        this.fetch_data()
    }

    reset = async () => {
        await this.setState({
            ...this.default_values()
        })
        this.fetch_data(true);
    }



    render() {
        let _state: any = { ...this.state };

        return (
            <KPIs
                title="Sentinel-3 Processing Orchestration"
            >
                {
                    this.state.log_file &&
                    <Modal 
                        className='medium'
                        opened={true} close={()=>{ this.setState({ log_file: undefined }) }}
                    >
                        <div className="modal-title">
                            LOG FILE
                            <ModalClose close={()=>{ this.setState({ log_file: undefined }) }}/>
                        </div>
                        <div className="modal-content"> 
                            <div className="kpi-8-file">
                                { JSON.stringify(this.state.log_file, null, 8) }
                            </div>
                        </div>
                    </Modal>
                }
                <div className="row-2">
                    <div className="row-2">
                        <div className="form-field">
                            <label>Start Date</label>
                            <input type="datetime-local"
                                value={this.state.updateStartDate}
                                // onChange={(e) => { this.update_filter({ updateStartDate: e.target.value }) }}
                                onChange={async (e) => {
                                    this.setState({ updateStartDate: e.target.value });
                                }}
                            />
                        </div>
                        <div className="form-field">
                            <label>Stop Date</label>
                            <input type="datetime-local"
                                value={this.state.updateStopDate}
                                // onChange={(e) => { this.update_filter({ updateStopDate: e.target.value }) }}
                                onChange={async (e) => {
                                    this.setState({ updateStopDate: e.target.value });
                                }}
                            />
                        </div>
                    </div>
                    <div className="row-2">
                        {
                            this.props.product_types?.product_types_filtered &&
                            <div className="form-field">
                                <label>Product Type</label>
                                <Select
                                    search
                                    value={this.state.productType}
                                    onChange={async(productType: any) => { 
                                        await this.setState({ productType }); 
                                        this.update_url()
                                        this.fetch_data(true)
                                    }}
                                    options={Object.keys(this.props.product_types.product_types_filtered).map((pt:any) => { return { label: pt, value: pt } })}
                                />
                            </div>
                        }
                    </div>
                </div>


                <div className={
                    classNames({
                        "custom-button small alt inline apply-changes": true,
                        "disabled": !(
                            this.state.updateStartDate !== this.state.startDate
                            || this.state.updateStopDate !== this.state.stopDate
                        ) 
                        // || date_surpassed
                    })}
                    onClick={this.applyChanges}
                >
                    <i className="fas fa-check" /> Apply Changes
                </div>
                <div className="custom-button small alt inline" onClick={this.reset}>
                    <i className="fas fa-redo-alt" /> Reset Filters
                </div>
                <br />
                <br />


                <br />
                <br />

                {/* GRAPH */}
                <div className="title-3">Results</div>
                <Tabs
                    tabs={[
                        {
                            label: <><i className="fas fa-th-list" /> Data</>,
                            content:<div className="kpi-data">
                                {
                                    this.state.refreshing ?
                                    <div className="centered">
                                        <Spinner />
                                    </div>
                                    :
                                    <>
                                        {
                                            this.state.orchestration_data &&
                                            <KPITable title="Quality Result" counter={this.state.orchestration_data.length}>
                                                {
                                                    this.state.loading &&
                                                    <KPIRefreshOverlay message="Fetching data..."/>
                                                }
                                                <table className="table-kpi">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: 450 }}>Product</th>
                                                            <th>Downlink Session Stop Date</th>
                                                            <th style={{ width: 100 }}>Status</th>
                                                            <th style={{ width: 100 }}>Log File</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.state.orchestration_data?.map((d: any, key: number) => (
                                                                <tr key={key}>
                                                                    <td style={{ width: 450 }}>{d.product_name}</td>
                                                                    <td>{d.downlink_session.stop_date_time}</td>
                                                                    <td style={{ width: 100 }}>{
                                                                        !nullUndefined(d.status_score) ?
                                                                        `${d.status_score}%`
                                                                        // d.status_score ? 
                                                                        //     d.status_score === '0' ? <><i className="fas fa-times-circle red"/> KO</>
                                                                        //     : d.status_score === '100' ?<><i className="fas fa-check-circle green"/> OK</>
                                                                        //     : d.status_score
                                                                        : "-"
                                                                    }</td>
                                                                    <td style={{ width: 100 }}>
                                                                        <div 
                                                                            className={classNames({
                                                                                "custom-button small blue rounded inline inverted" : true,
                                                                                "disabled": !d.log_file
                                                                            })}
                                                                            onClick={()=>this.setState({ log_file: d.log_file })}
                                                                        >
                                                                            <i className="fas fa-file-alt"/> Logs
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                </table>
                                            </KPITable>
                                        }
                                    </>
                                }
                            </div>
                        }
                    ]}
                />

                <br />
                <br />
                {/* DOWNLOAD */}
                <div className="title-3">Export</div>
                <p>Export Data used to compute the KPI</p>

                <FormFieldCheckbox
                    notSolid label="JSON Format"
                    value={!!this.state.json_format}
                    onChange={(json_format: boolean) => { this.setState({ json_format }) }}
                />
                <a
                    className={classNames({
                        "custom-button medium inline": true
                    })}
                    href={this.download_url()} download
                >
                    <i className="fas fa-cloud-download-alt" /> Export
                </a>
            </KPIs>
        );
    }

    download_url = () => {
        let params = [
            'expand=product, downlink_session',
            'export=true',
            `product_type=${this.state.productType}`,
            `start=${this.state.startDate}`,
            `stop=${this.state.stopDate}`
        ];

        if(this.state.json_format) params.push('format=json');
        
        return `${API_URL}/api/v1/processing_orchestration?${params.join('&')}`
    }

};


export default connect((state: any) => {
    return {
        kpi: state.kpi,
        product_types: state.product_types
    }
})(KPI8)